import React, { useCallback, useMemo, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Zoom from "./Zoom";
import "./Compare.scss";
import { useSelector } from "react-redux";
import index from "pages/DashBoard/DashboardForms";
import { ModalBody, ModalHeader, ModalTitle } from "react-bootstrap";

const returnUplopaddedDocName = (name) => {
  const splitName = name?.split("_") ?? [];
  const finalName = splitName.map(
    (item) => item.charAt(0).toUpperCase() + item.slice(1)
  );
  return finalName.join(" ");
};

const Compare = ({
  showCompareDocumentsModal,
  setShowCompareDocumentsModal,
}) => {
  // const [modalShow, setModalShow] = useState(false);
  const [show, setShow] = useState(false);

  const [items1, setItems1] = useState("");
  const [items2, setItems2] = useState("");

  const uploadedDocuments = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo
  )?.documents;

   const supportingDocuments = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo
  )?.supportingDocuments;


  const recursiveDocuments = useSelector(
    (state) => state?.dashboardDetailReducer?.userSubworkFlowInfo
  )?.source_data;

  const processDocumentCollection = (docCollection, parentKey, path) => {
    docCollection.forEach((documentItem, index) => {
      let counter = 0
      if (typeof documentItem === "object") {
        for (const docKey in documentItem) {
          if (typeof documentItem[docKey] === "object") {
            const subKey = `${parentKey}-${index+1}-${counter+1}`;
            const subPath = `${path}["${parentKey}"][${index}]`;
            processIndividualDocument(
              documentItem[docKey],
              subKey,
              index,
              subPath,
              docKey
            );
            counter++;
          }
        }
      }
    });
  };
  const processIndividualDocument = (
    docObject,
    parentKey,
    index,
    path,
    immediateParentKey
  ) => {
    for (const propertyKey in docObject) {
      const propertyValue = docObject[propertyKey];

      if (Array.isArray(propertyValue)) {
        processDocumentCollection(propertyValue, propertyKey, path);
      } else if (typeof propertyValue === "object" && propertyValue !== null) {
        const subKey = `${parentKey}-${propertyKey}`;
        const subPath = `${path}["${parentKey}"]`;
        processIndividualDocument(propertyValue, subKey, index, subPath);
      } else if (
        propertyKey === "document_type" &&
        docObject.hasOwnProperty("encrypted_filename") &&
        docObject.hasOwnProperty("original_name")
      ) {
        const fieldKey = `${parentKey}`;
        const accessPath = `${path}["${immediateParentKey}"]`;
        documents_object[fieldKey] = {
          ...docObject,
          accessPath: accessPath,
        };
      }
    }
  };

  const documents_object = {};

  const document = useMemo(() => {
    if (
      !uploadedDocuments ||
      Object.keys(uploadedDocuments).length === 0 ||
      uploadedDocuments.constructor !== Object
    ) {
      return [];
    }

    Object.keys(recursiveDocuments).forEach((key) => {
      const value = recursiveDocuments[key];
      if (Array.isArray(value)) {
        processDocumentCollection(value, key, "");
      }
    });

    let additionalSupportingDoc = [];

  if(supportingDocuments){
   additionalSupportingDoc = Object.fromEntries(
 supportingDocuments?.map(document => [document.field_label, document])
);
  }

    const allDocuments = { ...uploadedDocuments, ...documents_object, ...additionalSupportingDoc };

    return Object.keys(allDocuments)
      .map((key) => {
        const doc = allDocuments[key];
        if (doc?.encrypted_filename) {
          return {
            doc_name: key,
            doc_id: doc.encrypted_filename,
            name: doc.original_name,
            label: doc.field_label,
            doc_type: doc.document_type,
            accessPath: doc?.accessPath ? btoa(doc?.accessPath) : null,
          };
        }
        return null;
      })
      .filter(Boolean);
  }, [uploadedDocuments]);

  const option1Items = useMemo(() => {
    return document.filter((item) => item.doc_name !== items2);
  }, [document, items2]);

  const optionItems1 = useMemo(
    () => [
      <option key="-1" value="" disabled>
        Select a document
      </option>,
      ...option1Items.map((item, index) => (
        <option key={item.doc_id + index} value={item.doc_name}>
          {item.doc_name && returnUplopaddedDocName(item.doc_name)}
        </option>
      )),
    ],
    [option1Items]
  );

  const option2Items = useMemo(() => {
    return document.filter((item) => item.doc_name !== items1);
  }, [document, items1]);

  const optionItems2 = useMemo(
    () => [
      <option key="-1" value="" disabled>
        Select a document
      </option>,
      ...option2Items.map((item, index) => (
        <option key={item.doc_id + index} value={item.doc_name}>
          {item.doc_name && returnUplopaddedDocName(item.doc_name)}
        </option>
      )),
    ],
    [option2Items]
  );

  const handleClick = useCallback(() => {
    setShow(true);
    // setShowCompareDocumentsModal(false);
  }, []);

  const handleChange1 = useCallback((e) => {
    e.preventDefault();
    setItems1(e.target.value);
  }, []);

  const handleChange2 = useCallback((e) => {
    e.preventDefault();
    setItems2(e.target.value);
  }, []);

  const preview = useCallback(
    (itemName) => {
      return document.map((item) => {
        if (item.doc_name === itemName) return <Zoom imageObject={item} />;
      });
    },
    [document]
  );

  return (
    <>
      <>
        {/* <Modal
          contentClassName="custom-modal-style"
          show={showCompareDocumentsModal}
          onHide={() => setShowCompareDocumentsModal(false)}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName={show && "modal-90w"}
          centered
        >
          <Modal.Header closeButton className="modal_headers">
            <Modal.Title className=" compare-text">Compare Files</Modal.Title>
          </Modal.Header>
          <Modal.Body
            style={{
              backgroundColor: !show && "#ECF0F3",
              margin: !show && "2rem",
              marginTop: !show && "0rem",
            }}
            className="show-grid1 mt-0"
          >
            <Container>
              {document?.length > 0 && (
                <Row className="row-div">
                  <Col lg={show ? 6 : 5} xs={12} className="my-2">
                    <Form.Select
                      id="select1"
                      size="sm"
                      value={items1}
                      onChange={handleChange1}
                    >
                      {optionItems1}
                    </Form.Select>
                    {show ? preview(items1, document) : ""}
                  </Col>

                  <Col lg={show ? 6 : 5} xs={12} className="my-2">
                    <Form.Select
                      id="select2"
                      size="sm"
                      value={items2}
                      onChange={handleChange2}
                    >
                      {optionItems2}
                    </Form.Select>
                    {show ? preview(items2, document) : ""}
                  </Col>
                  {show ? (
                    ""
                  ) : (
                    <Col lg={2} xs={12} className="my-2">
                      <Button
                        disabled={items1 === "" || items2 === ""}
                        variant="primary"
                        onClick={handleClick}
                      >
                        Compare
                      </Button>{" "}
                    </Col>
                  )}
                </Row>
              )}
              {document.length === 0 && (
                <Row
                  className="row-div"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  No documents to compare
                </Row>
              )}
            </Container>
          </Modal.Body>
        </Modal> */}
        <Modal
          className="mt-5 p-0"
          show={showCompareDocumentsModal}
          onHide={() => setShowCompareDocumentsModal(false)}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName={show}
          centered
        >
          <ModalHeader closeButton>
            <ModalTitle className="fw-bold fs-20px text-theme">
              Compare Files
            </ModalTitle>
          </ModalHeader>
          <ModalBody
            className={`mb-4 mx-4 ${
              !show ? "bg-theme-grey-light-six" : "bg-white"
            }`}
          >
            <Container>
              {document?.length > 0 && (
                <Row className="p-0">
                  <Col lg={show ? 6 : 5} xs={12} className="mb-2">
                    <Form.Select
                      id="select1"
                      size="sm"
                      value={items1}
                      onChange={handleChange1}
                    >
                      {optionItems1}
                    </Form.Select>
                    {show ? preview(items1, document) : ""}
                  </Col>
                  <Col lg={show ? 6 : 5} xs={12} className="mb-2">
                    <Form.Select
                      id="select2"
                      size="sm"
                      value={items2}
                      onChange={handleChange2}
                    >
                      {optionItems2}
                    </Form.Select>
                    {show ? preview(items2, document) : ""}
                  </Col>
                  {show ? (
                    ""
                  ) : (
                    <Col lg={2} xs={12} className="mb-2">
                      <Button
                        className="w-100 primary_button"
                        disabled={items1 === "" || items2 === ""}
                        onClick={handleClick}
                      >
                        Compare
                      </Button>{" "}
                    </Col>
                  )}
                </Row>
              )}
              {document.length === 0 && (
                <Row
                  className="row-div"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  No documents to compare
                </Row>
              )}
            </Container>
          </ModalBody>
        </Modal>
      </>
    </>
  );
};

export default Compare;
